/**
 * Leitura das claims do access token, só para a interface decidir o que
 * mostrar. Não valida assinatura — quem confia no token é a API.
 */

/** Payload do JWT, ou `null` se o token não tiver o formato esperado. */
export function decodeJwtPayload(token: string | undefined): Record<string, unknown> | null {
  const part = token?.split('.')[1];
  if (!part) return null;
  try {
    const base64 = part
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(part.length / 4) * 4, '=');
    const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    const payload: unknown = JSON.parse(new TextDecoder().decode(bytes));
    return typeof payload === 'object' && payload !== null ? (payload as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

/**
 * O token diz a qual empresa o usuário pertence? Sem `tenant_id` a API
 * recusa tudo com 401 — é o caso de quem entra pela primeira vez com
 * Google/Apple sem que a conta tenha sido liberada (ver
 * infra/keycloak/README.md, DEFAULT_TENANT_ID).
 *
 * `undefined` quando não há token para olhar.
 */
export function tokenHasTenant(token: string | undefined): boolean | undefined {
  const claims = decodeJwtPayload(token);
  if (!claims) return undefined;
  const tenant = claims.tenant_id;
  return typeof tenant === 'string' && tenant.trim() !== '';
}
